import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'maskNumber',
})
export class MaskNumberPipe implements PipeTransform {
  transform(value: string | number, visibleDigits: number = 4, symbol?: string): string {
    if (!value) {
      return ''; // Return an empty string for empty or null input
    }

    const strValue = value.toString();
    const maskLength = Math.max(0, strValue.length - visibleDigits); // Ensure maskLength is not negative
    const masked = symbol ? symbol.repeat(maskLength) : '•'.repeat(maskLength);

    // If visibleDigits is 0, return only the masked part
    if (visibleDigits === 0) {
      return masked;
    }

    return masked + strValue.slice(-visibleDigits);
  }
}
